import api from '../api';
import TokenService from '../autentication/token.service';
import { captureDeliveryLocation, DeliveryLocationError } from './delivery-location.service';
import { DeliveryWorkFilter, DeliveryWorkOrder, DeliveryWorkSession, DeliveryWorkStatus } from '../../models/delivery-work';

const root = 'api/DeliveryWork';
// Never expose Axios configuration, which can contain device coordinates or bearer tokens.
const safely = async <T>(request: () => Promise<{ data: T }>): Promise<T> => {
  try { return (await request()).data; }
  catch (failure: unknown) {
    // Read only the explicit validation code; never expose a request/config/body.
    const response = failure as { response?: { status?: number; data?: { code?: string } } };
    if (response?.response?.status === 400 && response.response.data?.code === 'DELIVERY_LOCATION_REQUIRED')
      throw new DeliveryLocationError('InvalidData');
    throw new Error('Unable to load or save delivery activity. Refresh and try again.');
  }
};
const today = () => safely<DeliveryWorkStatus>(() => api.get(`${root}/today`));
const change = async (action: 'start' | 'end', options?: { signal?: AbortSignal; onCaptured?: () => void }) => {
  const actor = TokenService.getUser()?.userID;
  const location = await captureDeliveryLocation(options?.signal);
  if (!actor || actor !== TokenService.getUser()?.userID) throw new Error('Your session changed. Refresh and try again.');
  if (options?.signal?.aborted) throw new DOMException('Location check cancelled.', 'AbortError');
  options?.onCaptured?.();
  return safely<DeliveryWorkStatus>(() => api.post(`${root}/${action}`, location, { signal: options?.signal }));
};
const invoiceCheck = (orderId: number) => safely<{ startRequired: boolean }>(() => api.get(`${root}/invoice-check/${orderId}`));
const report = (filter: DeliveryWorkFilter) => safely<{ totalCount: number; rows: DeliveryWorkSession[] }>(() => api.get(`${root}/report`, { params: filter }));
const executives = () => safely<{ id: number; name: string; phone: string }[]>(() => api.get(`${root}/executives`));
const orders = (executiveId: number, date: string) => safely<DeliveryWorkOrder[]>(() => api.get(`${root}/orders`, { params: { executiveId, date } }));
const deliveryWorkService = { today, change, invoiceCheck, report, executives, orders };
export default deliveryWorkService;
